/*
 * Copyright 2023
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2023.9.17 at 18:2
 */

export default () => {
    const initalFontSize = getComputedStyle(document.documentElement).fontSize;
    // const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const contrastMore = window.matchMedia('(prefers-contrast: more)');
    const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
    const prefersLightScheme = window.matchMedia('(prefers-color-scheme: light)');

    const themeToggles = document.querySelectorAll('#wp-perf__theme-toggle');
    const themeSwitches = document.querySelectorAll('#wp-perf__theme-switch');
    const increaseFontSizeToggles = document.querySelectorAll('#wp-perf__theme-font-increase');
    const decreaseFontSizeToggles = document.querySelectorAll('#wp-perf__theme-font-decrease');
    const contrastToggles = document.querySelectorAll('#wp-perf__theme-contrast');
    const grayscaleToggles = document.querySelectorAll('#wp-perf__theme-grayscale');
    const resetToggles = document.querySelectorAll('#wp-perf__theme-font-reset');

    // Funktion zum URL-Encodieren von Text
    const encodeForMailto = (text) => encodeURIComponent(text);

    // E-Mail-Adresse und Nachrichtentext
    const emailAddress = "hallo@studio-leeflang.com";
    const emailSubject = "Anfrage an Studio Leeflang";
    const emailBody = "Hallo Studio Leeflang, ich habe eine Anfrage. Bitte kontaktiere mich.";

    const saveAccessiblitySettings = () => {
        if (document.documentElement.classList.contains('contrast')) {
            localStorage.contrast = true;
        } else {
            localStorage.contrast = false;
        }
        if (document.documentElement.classList.contains('grayscale')) {
            localStorage.grayscale = true;
        } else {
            localStorage.grayscale = false;
        }

        localStorage.theme = document.documentElement.classList.contains('dark') ? 'dark' : 'light';
        setComponents(localStorage.theme);
        localStorage.fontSize = getComputedStyle(document.documentElement).fontSize;
    };

    const setContrastFromStorageOrUserPreference = () => {
        const contrast = localStorage.contrast;

        if ((contrast && contrast == 'true') || contrastMore.matches) {
            document.documentElement.classList.add('contrast');
        }
    };
    const stateStore = new store();
    setComponents = (mode) => {
        const components = document.querySelectorAll('gif-component');
        stateStore.setState('mode', mode);

        components.forEach((component) => {
            component.setAttribute('mode', mode);
        });
    };
    
    const setDarkModeFromStorageOrUserPreference = () => {
        const currentTheme = localStorage.getItem('theme');
    
        if (currentTheme) {
            if (currentTheme === 'dark') {
                document.documentElement.classList.add('dark');
                document.documentElement.classList.remove('light');
                setComponents('dark');
            } else if (currentTheme === 'light') {
                document.documentElement.classList.add('light');
                document.documentElement.classList.remove('dark');
                setComponents('light');
            }
        } else {
            document.documentElement.classList.add('dark');
            document.documentElement.classList.remove('light');
            localStorage.setItem('theme', 'dark');
            setComponents('dark');
        }
    };

    // const setDarkModeFromStorageOrUserPreference = () => {
    //     const currentTheme = localStorage.getItem('theme');

    //     if (currentTheme) {
    //         if (currentTheme == 'dark') {
    //             document.documentElement.classList.add('dark');
    //             document.documentElement.classList.remove('light');
    //             setComponents('dark');
    //         } else if (currentTheme == 'light') {
    //             document.documentElement.classList.add('light');
    //             document.documentElement.classList.remove('dark');
    //             setComponents('light');
    //         }
    //     } else {
    //         if (prefersDarkScheme.matches) {
    //             document.documentElement.classList.add('dark');
    //             document.documentElement.classList.remove('light');
    //             localStorage.setItem('theme', 'dark');
    //             setComponents('dark');
    //         } else {
    //             document.documentElement.classList.add('light');
    //             document.documentElement.classList.remove('dark');
    //             localStorage.setItem('theme', 'light');
    //             setComponents('light');
    //         }
    //     }
    // };

    const addMenuEventListeners = () => {
        increaseFontSizeToggles.forEach((increaseFontSize) => {
            increaseFontSize.addEventListener('click', (ev) => {
                ev.preventDefault();
                const currentSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
                if (currentSize <= 22) {
                    document.documentElement.style.fontSize = currentSize * 1.1 + 'px';
                }
                saveAccessiblitySettings();
            });
        });
        decreaseFontSizeToggles.forEach((decreaseFontSize) => {
            decreaseFontSize.addEventListener('click', (ev) => {
                ev.preventDefault();
                const currentSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
                if (currentSize >= 17) {
                    document.documentElement.style.fontSize = currentSize * 0.9 + 'px';
                }
                saveAccessiblitySettings();
            });
        });
        resetToggles.forEach((reset) => {
            reset.addEventListener('click', (ev) => {
                ev.preventDefault();
                document.documentElement.style.fontSize = initalFontSize;
                document.documentElement.style.fontSize = initalFontSize;
                document.documentElement.classList.remove('contrast');
                document.documentElement.classList.remove('grayscale');
                document.documentElement.classList.remove('dark');
                saveAccessiblitySettings();
            });
        });
        contrastToggles.forEach((contrast) => {
            contrast.addEventListener('click', (ev) => {
                ev.preventDefault();
                document.documentElement.classList.toggle('contrast');
                saveAccessiblitySettings();
            });
        });
        grayscaleToggles.forEach((grayscale) => {
            grayscale.addEventListener('click', (ev) => {
                ev.preventDefault();
                document.documentElement.classList.toggle('grayscale');
                saveAccessiblitySettings();
            });
        });
        themeToggles.forEach((themeToggle) => {
            themeToggle.addEventListener('click', (ev) => {
                ev.preventDefault();
                let theme = document.documentElement.classList.contains('light') ? 'light' : 'dark';

                if (theme == 'dark') {
                    document.documentElement.classList.remove('dark');
                    document.documentElement.classList.add('light');
                    setComponents('light');
                } else {
                    setComponents('dark');
                    document.documentElement.classList.add('dark');
                    document.documentElement.classList.remove('light');
                }

                if (themeSwitches?.length) {
                    themeSwitches.forEach((themeSwitch) => {
                        themeSwitch.checked = theme !== 'dark';
                    });
                }

                saveAccessiblitySettings();
            });
        });
        themeSwitches.forEach((themeSwitch) => {
            const currentTheme = localStorage.getItem('theme');
            themeSwitch.checked = currentTheme === 'dark';

            // Kommtentierter Code, der den Dark Mode toggelt
            // themeSwitch.addEventListener('click', (ev) => {
            //     let theme = document.documentElement.classList.contains('light') ? 'light' : 'dark';
            //     if (theme == 'dark') {
            //         document.documentElement.classList.remove('dark');
            //         document.documentElement.classList.add('light');
            //     } else {
            //         document.documentElement.classList.add('dark');
            //         document.documentElement.classList.remove('light');
            //     }
            //     saveAccessiblitySettings();
            // });

            // Neuen Event-Listener hinzufügen, der eine E-Mail öffnet
            themeSwitch.addEventListener('click', (ev) => {
                ev.preventDefault();
                const mailtoLink = `mailto:${emailAddress}?subject=${encodeForMailto(emailSubject)}&body=${encodeForMailto(emailBody)}`;
                window.location.href = mailtoLink;
            });
        });
    };

    const init = () => {
        addMenuEventListeners();

        if (localStorage.grayscale == 'true') {
            document.documentElement.classList.add('grayscale');
        }

        if (localStorage.fontSize) {
            document.documentElement.style.fontSize = localStorage.fontSize;
        }

        setContrastFromStorageOrUserPreference();
        setDarkModeFromStorageOrUserPreference();

        contrastMore.addEventListener('change', () => {
            setContrastFromStorageOrUserPreference();
        });
        prefersDarkScheme.addEventListener('change', () => {
            setDarkModeFromStorageOrUserPreference();
        });
        prefersLightScheme.addEventListener('change', () => {
            setDarkModeFromStorageOrUserPreference();
        });
    };

    init();
};